import { useEffect } from 'react';

import {getCurrentLayout} from "../../../appLayout";
import sqftShapeManager from "../../components/canvas/store/sqftShapeManager";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";
import store from "../../../../store";

const useUpdateCabinetFeatures = () => {

  useEffect (() => {
    const layout = getCurrentLayout();
    const state = store.getState()
    const { wizardConflictingSteps } = state.wizardState;
    const hasWizardConflicts = wizardConflictingSteps && wizardConflictingSteps.length > 0;

    //do not auto update colour if there is conflicts
    if (isSFTCabinetsGroup() && layout.parts.Cabinet && !hasWizardConflicts) {
      if (layout.parts.Cabinet.topCabinet) {
        const topCabinetFeature = layout.parts.Cabinet.topCabinet.activeFeature;
        sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(topCabinetFeature);
      }
      if (layout.parts.Cabinet.bottomCabinet) {
        const bottomCabinetFeature = layout.parts.Cabinet.bottomCabinet.activeFeature;
        sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(bottomCabinetFeature);
      }
    }
  }, []);
};

export default useUpdateCabinetFeatures;
